import TrendingDownRoundedIcon from "@mui/icons-material/TrendingDownRounded";
import TrendingFlatRoundedIcon from "@mui/icons-material/TrendingFlatRounded";
import TrendingUpRoundedIcon from "@mui/icons-material/TrendingUpRounded";
import { Box, Typography } from "@mui/material";
import { ReactNode } from "react";
import { TrendValue } from "./types";

const STABLE_THRESHOLD = 5;

const formatPercent = (value: number): string => `${value > 0 ? "+" : ""}${value.toFixed(1)}%`;

const Pill = ({ color, bgColor, icon, label }: { color: string; bgColor: string; icon?: ReactNode; label: string }) => (
  <Box
    sx={{
      display: "inline-flex",
      alignItems: "center",
      gap: 0.5,
      color,
      bgcolor: bgColor,
      borderRadius: 999,
      px: 1,
      py: 0.25,
    }}
  >
    {icon}
    <Typography variant="body2" sx={{ color, fontWeight: 600 }}>
      {label}
    </Typography>
  </Box>
);

export const TrendIndicator = ({ trend }: { trend: TrendValue }) => {
  if (trend === "New") {
    return <Pill color="info.main" bgColor="info.lighter" label="New" />;
  }
  if (trend === "N/A") {
    return <Pill color="text.secondary" bgColor="greyscale.100" label="N/A" />;
  }

  const direction = trend > STABLE_THRESHOLD ? "up" : trend < -STABLE_THRESHOLD ? "down" : "stable";
  const color = direction === "up" ? "success.main" : direction === "down" ? "error.main" : "text.secondary";
  const bgColor = direction === "up" ? "success.lighter" : direction === "down" ? "error.lighter" : "greyscale.100";
  const Icon = direction === "up" ? TrendingUpRoundedIcon : direction === "down" ? TrendingDownRoundedIcon : TrendingFlatRoundedIcon;

  return <Pill color={color} bgColor={bgColor} icon={<Icon sx={{ fontSize: 16 }} />} label={formatPercent(trend)} />;
};
